import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Import helpers
import { stripExtensionFromFileName } from './helpers';
import { HIGHLIGHTED_DOCUMENTS_NAMES } from 'helpers/variables';

// Import styles
import { ButtonStyled, ListElement, ListTitle, ListWrapper } from './styles';
import { Info } from 'components/views/user/styles';

function FileList({ files, configurator }) {
	const { t } = useTranslation();

	return (
		<ListWrapper>
			{files?.length ? (
				files.map(({ file_name, model_id, url }, index) => (
					<ListElement key={`${index}_${model_id}`} configurator={configurator}>
						<ListTitle configurator={configurator} isHighlighted={HIGHLIGHTED_DOCUMENTS_NAMES.includes(file_name)}>
							{stripExtensionFromFileName(file_name)}
						</ListTitle>
						<ButtonStyled as="a" href={url} target="_blank" rel="noopener noreferrer" configurator={configurator} modifiers={['small', 'text']}>
							{t('packets_slider_btn_show')}
						</ButtonStyled>
					</ListElement>
				))
			) : (
				<Info>{t('payment_active_payment_methods_no_data')}</Info>
			)}
		</ListWrapper>
	);
}

FileList.defaultProps = {
	configurator: false
};

FileList.propTypes = {
	files: PropTypes.array,
	configurator: PropTypes.bool
};

export default FileList;
